"use strict";

import $ from "jquery";
import scrollToElm from "../../Shared/helpers/helper.scrollToElm";

function init() {
    $("[data-target-type]").each(function () {
        const link = $(this);
        let href = "#";
        let hasTarget = false;

        const targetType = link.data("targetType");
        if (targetType !== "") {
            const targetSelector = targetType
                .toString()
                .split(",")
                .map(function (type) {
                    return `[data-module-type="${type}"]`;
                })
                .join(", ");
            const target = $(targetSelector);
            if (target.length) {
                const targetId = $(target[0]).attr("id");
                if (targetId) {
                    href = `#${targetId}`;
                    hasTarget = true;
                }
            }
        }
        if (!hasTarget) {
            const dataHref = link.data("href");
            if (dataHref && dataHref !== "") {
                href = dataHref;
            }
        }
        link.attr("href", href);

        link.on("click", function (e) {
            const scrollTargetId = $(this).attr("href");
            if (
                scrollTargetId.length > 1 &&
                scrollTargetId.indexOf("#") === 0
            ) {
                const scrollTarget = $(scrollTargetId);
                if (scrollTarget.length) {
                    e.preventDefault();
                    scrollToElm(scrollTarget);
                }
            }
        });
    });
}

export default {
    init,
};
